import React from 'react'
import ShoutHOC from '../components/Shout/ShoutHOC'
import Shout from '../components/Shout/v2/Index'
export default function ShoutV2(props) {
  const {
    // businessData,
    // configData,
    // pageTitle,
    gonationID,
    // locationIndex,
    variantName
    // options,
  } = props
  const Component = ShoutHOC(gonationID, Shout)
  const variant = variantName ? variantName : 'shoutSectionV2'

  return <Component {...props} variantName={variant} />
}
